export const authConstants = {
  ADMIN_LOGIN_REQUEST: "ADMIN_LOGIN_REQUEST",
  ADMIN_LOGIN_SUCCESS: "ADMIN_LOGIN_SUCCESS",
  ADMIN_LOGIN_FAILURE: "ADMIN_LOGIN_FAILURE",
  ADMIN_LOGOUT_REQUEST: "ADMIN_LOGOUT_REQUEST",
  ADMIN_LOGOUT_SUCCESS: "ADMIN_LOGOUT_SUCCESS",
  ADMIN_LOGOUT_FAILURE: "ADMIN_LOGOUT_FAILURE",
  GET_ADMIN_REQUEST: "GET_ADMIN_REQUEST",
  GET_ADMIN_SUCCESS: "GET_ADMIN_SUCCESS",
  GET_ADMIN_FAILURE: "GET_ADMIN_FAILURE",
};

export const categoryConstants = {
  CREATE_CATEGORY_REQUEST: "CREATE_CATEGORY_REQUEST",
  CREATE_CATEGORY_SUCCESS: "CREATE_CATEGORY_SUCCESS",
  CREATE_CATEGORY_FAILURE: "CREATE_CATEGORY_FAILURE",
  GET_CATEGORIES_REQUEST: "GET_CATEGORIES_REQUEST",
  GET_CATEGORIES_SUCCESS: "GET_CATEGORIES_SUCCESS",
  GET_CATEGORIES_FAILURE: "GET_CATEGORIES_FAILURE",
  DELETE_CATEGORY_REQUEST: "DELETE_CATEGORY_REQUEST",
  DELETE_CATEGORY_SUCCESS: "DELETE_CATEGORY_SUCCESS",
  DELETE_CATEGORY_FAILURE: "DELETE_CATEGORY_FAILURE",
  UPDATE_CATEGORY_REQUEST: "UPDATE_CATEGORY_REQUEST",
  UPDATE_CATEGORY_SUCCESS: "UPDATE_CATEGORY_SUCCESS",
  UPDATE_CATEGORY_FAILURE: "UPDATE_CATEGORY_FAILURE",
};

export const countryConstants = {
  GET_COUNTRIES_REQUEST: "GET_COUNTRIES_REQUEST",
  GET_COUNTRIES_SUCCESS: "GET_COUNTRIES_SUCCESS",
  GET_COUNTRIES_FAILURE: "GET_COUNTRIES_FAILURE",
  CREATE_COUNTRY_REQUEST: "CREATE_COUNTRY_REQUEST",
  CREATE_COUNTRY_SUCCESS: "CREATE_COUNTRY_SUCCESS",
  CREATE_COUNTRY_FAILURE: "CREATE_COUNTRY_FAILURE",
  UPDATE_COUNTRY_REQUEST: "UPDATE_COUNTRY_REQUEST",
  UPDATE_COUNTRY_SUCCESS: "UPDATE_COUNTRY_SUCCESS",
  UPDATE_COUNTRY_FAILURE: "UPDATE_COUNTRY_FAILURE",
  DELETE_COUNTRY_REQUEST: "DELETE_COUNTRY_REQUEST",
  DELETE_COUNTRY_SUCCESS: "DELETE_COUNTRY_SUCCESS",
  DELETE_COUNTRY_FAILURE: "DELETE_COUNTRY_FAILURE",
};

export const warehouseConstants = {
  GET_WAREHOUSES_REQUEST: "GET_WAREHOUSES_REQUEST",
  GET_WAREHOUSES_SUCCESS: "GET_WAREHOUSES_SUCCESS",
  GET_WAREHOUSES_FAILURE: "GET_WAREHOUSES_FAILURE",
  CREATE_WAREHOUSE_REQUEST: "CREATE_WAREHOUSE_REQUEST",
  CREATE_WAREHOUSE_SUCCESS: "CREATE_WAREHOUSE_SUCCESS",
  CREATE_WAREHOUSE_FAILURE: "CREATE_WAREHOUSE_FAILURE",
  UPDATE_WAREHOUSE_REQUEST: "UPDATE_WAREHOUSE_REQUEST",
  UPDATE_WAREHOUSE_SUCCESS: "UPDATE_WAREHOUSE_SUCCESS",
  UPDATE_WAREHOUSE_FAILURE: "UPDATE_WAREHOUSE_FAILURE",
  DELETE_WAREHOUSE_REQUEST: "DELETE_WAREHOUSE_REQUEST",
  DELETE_WAREHOUSE_SUCCESS: "DELETE_WAREHOUSE_SUCCESS",
  DELETE_WAREHOUSE_FAILURE: "DELETE_WAREHOUSE_FAILURE",
};

export const shippingCompanyConstants = {
  GET_SHIPPING_COMPANIES_REQUEST: "GET_SHIPPING_COMPANIES_REQUEST",
  GET_SHIPPING_COMPANIES_SUCCESS: "GET_SHIPPING_COMPANIES_SUCCESS",
  GET_SHIPPING_COMPANIES_FAILURE: "GET_SHIPPING_COMPANIES_FAILURE",
  CREATE_SHIPPING_COMPANY_REQUEST: "CREATE_SHIPPING_COMPANY_REQUEST",
  CREATE_SHIPPING_COMPANY_SUCCESS: "CREATE_SHIPPING_COMPANY_SUCCESS",
  CREATE_SHIPPING_COMPANY_FAILURE: "CREATE_SHIPPING_COMPANY_FAILURE",
  UPDATE_SHIPPING_COMPANY_REQUEST: "UPDATE_SHIPPING_COMPANY_REQUEST",
  UPDATE_SHIPPING_COMPANY_SUCCESS: "UPDATE_SHIPPING_COMPANY_SUCCESS",
  UPDATE_SHIPPING_COMPANY_FAILURE: "UPDATE_SHIPPING_COMPANY_FAILURE",
  DELETE_SHIPPING_COMPANY_REQUEST: "DELETE_SHIPPING_COMPANY_REQUEST",
  DELETE_SHIPPING_COMPANY_SUCCESS: "DELETE_SHIPPING_COMPANY_SUCCESS",
  DELETE_SHIPPING_COMPANY_FAILURE: "DELETE_SHIPPING_COMPANY_FAILURE",
};

export const priceConstants = {
  GET_PRICES_REQUEST: "GET_PRICES_REQUEST",
  GET_PRICES_SUCCESS: "GET_PRICES_SUCCESS",
  GET_PRICES_FAILURE: "GET_PRICES_FAILURE",
  CREATE_PRICE_REQUEST: "CREATE_PRICE_REQUEST",
  CREATE_PRICE_SUCCESS: "CREATE_PRICE_SUCCESS",
  CREATE_PRICE_FAILURE: "CREATE_PRICE_FAILURE",
  UPDATE_PRICE_REQUEST: "UPDATE_PRICE_REQUEST",
  UPDATE_PRICE_SUCCESS: "UPDATE_PRICE_SUCCESS",
  UPDATE_PRICE_FAILURE: "UPDATE_PRICE_FAILURE",
  DELETE_PRICE_REQUEST: "DELETE_PRICE_REQUEST",
  DELETE_PRICE_SUCCESS: "DELETE_PRICE_SUCCESS",
  DELETE_PRICE_FAILURE: "DELETE_PRICE_FAILURE",
};

export const shippingCategoryConstants = {
  GET_SHIPPING_CATEGORIES_REQUEST: "GET_SHIPPING_CATEGORIES_REQUEST",
  GET_SHIPPING_CATEGORIES_SUCCESS: "GET_SHIPPING_CATEGORIES_SUCCESS",
  GET_SHIPPING_CATEGORIES_FAILURE: "GET_SHIPPING_CATEGORIES_FAILURE",
  CREATE_SHIPPING_CATEGORY_REQUEST: "CREATE_SHIPPING_CATEGORY_REQUEST",
  CREATE_SHIPPING_CATEGORY_SUCCESS: "CREATE_SHIPPING_CATEGORY_SUCCESS",
  CREATE_SHIPPING_CATEGORY_FAILURE: "CREATE_SHIPPING_CATEGORY_FAILURE",
  UPDATE_SHIPPING_CATEGORY_REQUEST: "UPDATE_SHIPPING_CATEGORY_REQUEST",
  UPDATE_SHIPPING_CATEGORY_SUCCESS: "UPDATE_SHIPPING_CATEGORY_SUCCESS",
  UPDATE_SHIPPING_CATEGORY_FAILURE: "UPDATE_SHIPPING_CATEGORY_FAILURE",
  DELETE_SHIPPING_CATEGORY_REQUEST: "DELETE_SHIPPING_CATEGORY_REQUEST",
  DELETE_SHIPPING_CATEGORY_SUCCESS: "DELETE_SHIPPING_CATEGORY_SUCCESS",
  DELETE_SHIPPING_CATEGORY_FAILURE: "DELETE_SHIPPING_CATEGORY_FAILURE",
};
